import React, { useContext } from "react"

import List from "@material-ui/core/List"
import ListItem, { ListItemProps } from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Collapse from "@material-ui/core/Collapse"

import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import clsx from "clsx"

import {
  AllPlaces,
  CreatePageIcon,
  NavigationButtonProps,
  NavigationMessage,
  useLocationSelectedIcon,
  useNavigateHandler,
  usePlaceIcon,
} from "./navigation-places"
import { ReactFC } from "../types"
import { useAppDrawerStyles } from "../navigation-ui/drawer"
import { BottomNavigationAction, useTheme } from "@material-ui/core"
import { Link, useLocation } from "react-router-dom"
import { FormattedMessage } from "react-intl"
import { IconType } from "react-icons"
import { ScreenContext } from "./screen-context"
import CreateModal from "Modals/Create/CreateModal"
import { useOpenCreateModal } from "./useOpenCreateModal"


export type NavigationItemProps = NavigationButtonProps & {
  underlyingProps?: any
}

export const NavigationItem: ReactFC<NavigationItemProps> = ({
  place,
  level,
  underlyingProps,
}) => {
  const { href } = useNavigateHandler(place)
  const Icon = usePlaceIcon(place, level)

  return (
    <MenuListItemWithSelection
      href={href}
      icon={Icon}

      underlyingProps={underlyingProps}
      level={level}
    >
      <NavigationMessage place={place} level={level} />
    </MenuListItemWithSelection>
  )
}

interface NavigationMenuListItemCoreProps {
  icon: React.ReactNode
  nested?: boolean
}

export type NavigationMenuListItemProps = ListItemProps<"button", any> &
  NavigationMenuListItemCoreProps
export const MenuListItem: ReactFC<NavigationMenuListItemProps> = (props) => {
  const { setDrawerOpen } = useContext(ScreenContext)
  const { icon, children, href, nested, onClick, className, ...other } = props
  const classes = useAppDrawerStyles()
  return (
    <ListItem
      button
      component={Link}
      to={href}
      {...other}
      className={clsx(className, nested && classes.nested)}
      onClick={() => setDrawerOpen(false)}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>{children}</ListItemText>
    </ListItem>
  )
}

export const BottomActionItem: ReactFC = ({ place, level }) => {
  const { href } = useNavigateHandler(place)

  const { color, size } = useLocationSelectedIcon(href)
  const Icon = usePlaceIcon(place, level)
  return (
    <BottomNavigationAction
      label={"page"}
      icon={<Icon color={color} size={size} />}
      component={Link}
      to={href}
      showLabel={false}
    />
  )
}

export const NestedNavigationItem: ReactFC<NavigationItemProps> = (props) => {
  return <NavigationItem {...props} level={1} />
}

export const ItemWithSubMenu: ReactFC<NavigationButtonProps> = ({
  place,
  children,
}) => {
  const Icon = usePlaceIcon(place)
  const [open, setOpen] = React.useState(true)

  const handleClick = () => {
    setOpen(!open)
  }
  return (
    <>
      <ListItem button onClick={handleClick}>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText>
          <NavigationMessage place={place} />
        </ListItemText>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </>
  )
}

export const NavigationSubMenu: ReactFC<{
  places: ReadonlyArray<AllPlaces>
}> = ({ places }) => {
  return (
    <ItemWithSubMenu place={places[0]}>
      {places.map((p) => (
        <NestedNavigationItem place={p} key={p} />
      ))}
    </ItemWithSubMenu>
  )
}

export const CreatePageMenuItem: ReactFC<NavigationMenuListItemProps> = (
  props
) => {
  const [openModal, setOpenModal] = useOpenCreateModal()

  return (
    <>
      <CreateModal handleClose={() => setOpenModal(false)} open={openModal} />

      <ListItem
        button


        onClick={() => setOpenModal(!openModal)}
      >
        <ListItemIcon><CreatePageIcon /></ListItemIcon>
        <ListItemText>
          {" "}
          <FormattedMessage id="navigation.create" />
        </ListItemText>
      </ListItem>
    </>
  )
}
export interface MenuListItemWithSelectionProps {
  href: string
  icon: IconType
  underlyingProps?: any
  level?: number

}

export const MenuListItemWithSelection: ReactFC<MenuListItemWithSelectionProps> = (
  props
) => {
  const {
    href,
    icon: Icon,
    underlyingProps,
    children,

    level = 0,
  } = props
  const theme = useTheme()
  const location = useLocation()
  const selected = href === location.pathname
  const icon = (selected && (
    <Icon color={theme.palette.primary.contrastText} />
  )) || <Icon />
  return (
    <MenuListItem

      href={href}
      icon={icon}
      {...underlyingProps}
      nested={level > 0}
      selected={selected}
    >
      {children}
    </MenuListItem>
  )
}
